import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { getAccessToken } from './AuthProvider';

/**
 * Hook to check if the current user is an admin
 * Also validates against backend to ensure consistency
 */
export const useIsAdmin = () => {
  const { accounts } = useMsal();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!accounts || accounts.length === 0) {
        setIsAdmin(false);
        setIsChecking(false);
        return;
      }

      try {
        // Get the user email from token claims
        const userEmail = accounts[0]?.username || 
                         accounts[0]?.idTokenClaims?.preferred_username ||
                         accounts[0]?.idTokenClaims?.email;

        console.log('[Admin Check] User email from token:', userEmail);
        console.log('[Admin Check] All claims:', accounts[0]?.idTokenClaims);

        if (!userEmail) {
          console.log('[Admin Check] No user email found');
          setIsAdmin(false);
          setIsChecking(false);
          return;
        }

        // Verify with backend API
        const apiUrl = `${process.env.REACT_APP_API_URL || 'https://localhost:5001'}/api/admin/check`;
        console.log('[Admin Check] Calling API:', apiUrl);
        
        // Get access token for the backend API
        const accessToken = await getAccessToken();
        console.log('[Admin Check] Got access token');
        
        const response = await fetch(apiUrl, {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
          },
        });

        console.log('[Admin Check] Response status:', response.status);

        if (response.ok) {
          const data = await response.json();
          console.log('[Admin Check] Response data:', data);
          setIsAdmin(true);
        } else {
          const errorText = await response.text();
          console.log('[Admin Check] Error response:', errorText);
          setIsAdmin(false);
        }
      } catch (error) {
        // If API call fails, user is not admin
        console.error('[Admin Check] Failed:', error);
        setIsAdmin(false);
      } finally {
        setIsChecking(false);
      }
    };

    checkAdminStatus();
  }, [accounts]);

  return { isAdmin, isChecking };
};
